"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ttable_ru = void 0;
exports.ttable_ru = {
    byDefault: 'По умолчанию',
    filter: 'Фильтр',
    resultsOption: 'Результаты не найдены',
    clearAll: 'Сбросить всё',
    hideColumn: 'Скрыть столбец',
    hideOpenColumns: 'Скрыть/ отобразить столбцы',
    columnVisibility: 'Состав таблицы',
    visibleColumns: 'Включенные столбцы',
    commonColumns: 'Основные столбцы',
    pagingInfo: 'Отображены c {from, number} по {to, number} из {count, number}',
    pagingInfoIfNull: 'Записи не найдены',
    rowsPerPage: 'Отображать по:',
    presetName: 'Название пресета',
    placeholderPresetName: 'Введите название пресета',
    savePreset: 'Сохранить пресет',
    save: 'Сохранить',
    changeExistedPreset: 'Изменить существующий',
    invalidDateMessage: 'Недопустимый формат даты',
    maxDateMessage: 'Дата не может быть позже текущей даты',
    deletionPreset: 'Удаление пресета',
    confirmDeletionPreset: 'Вы действительно хотите удалить пресет "{preset}"?',
    confirm: 'Подтвердить',
    cancel: 'Отменить',
    from: 'C',
    to: 'по',
    presetManagement: 'Управление пресетами',
    preset: 'Пресет',
    common: 'Общий',
    default: 'По умолчанию',
    accessibilityRule: 'Правило доступности',
    upload: 'Выгрузить в файл',
    all: 'Все',
    minOneDefault: 'Минимум один пресет по умолчанию должен быть доступен всем',
    notUniqueSharedRule: 'Правила доступности не должны пересекаться: роль пользователя может быть указана только в одном пресете по умолчанию',
    expandRecords: 'Развернуть записи',
    collapseEntries: 'Свернуть записи',
    lastState: 'Последнее состояние',
    group: 'Группа',
    column: 'Столбец',
    noColumnFilter: 'Чтобы увидеть доступные для отображения столбцы, воспользуйтесь фильтрами выше',
};
